/*
 * @Description 组件 LicenseDropDown 授头部权
 * @Author 
 * @Date 
 */
/* HTML */
<template>
    <div>
    	<el-dropdown type="primary" trigger="click" v-show="!$checkEmpty(authInfo)">
			<span class="el-dropdown-link">
				<span>
					<template>
						<span v-if="$checkEmpty(authInfo) || authInfo.warningFlag" class="dp-link-icon icon-license-warning"></span>
						<span v-else class="dp-link-icon icon-license-success"></span>
					</template>
<!--					{{$checkEmpty(authInfo) || authInfo.surplusDays < 0 ? '已过期' : '已授权'}}-->
				</span>
<!--				<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
			</span>
	        <el-dropdown-menu slot="dropdown">
				<!-- 授权信息面板 start -->
				<div :class="{'sub-license-box': true,'license-auth-none': $checkEmpty(authInfo)}">
					<div class="license-info-item">
						<template>
							<b :class="{'license-auth-state': true,'license-state-success': (!$checkEmpty(authInfo) && !authInfo.warningFlag),'license-state-error': ($checkEmpty(authInfo) || authInfo.warningFlag)}">{{$checkEmpty(authInfo) || authInfo.surplusDays < 0 ? '已过期' : '已授权'}}</b>
						</template>
						<span v-if="!$checkEmpty(authInfo)" class="license-auth-time">&ensp;&ensp;<span>{{authInfo.expirationDate}}</span> 到期</span>
						<template>
							<span v-if="$checkEmpty(authInfo)" class="sub-license-btn" @click="warrant">授权</span>
						</template>
					</div>
					<div v-if="!$checkEmpty(authInfo)" :class="{'license-msg-item': true, 'license-msg-warning': !(authInfo.surplusDays >= 30)}">
						<span v-if="authInfo.surplusDays >= 0">还有 <b>{{authInfo.surplusDays}}</b> 天到期</span>
						<span v-if="authInfo.surplusDays < 0">已过期 <b>{{Math.abs(authInfo.surplusDays)}}</b> 天</span>
						<span class="sub-license-btn" @click="warrant">续期</span>
					</div>
				</div>
				<!-- 授权信息面板 end -->
	        </el-dropdown-menu>
	    </el-dropdown>
	    
	    <!-- 授权 dialog -->
	    <WarrantDialog ref="warrantDialog" @callback="searchAuthInfo" />
	    
    </div>
</template>

/* JS */
<script>
	// API 资源
	import ApiOam from '@/request/api-oam';
	
	// 组件 授权
  import WarrantDialog from '@/components_index/License/WarrantDialog';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "LicenseDropDown",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 授权
			WarrantDialog,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				
				// 授权信息
                authInfo: null,
				
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			// 授权信息
			this.searchAuthInfo();
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			
			/**
			 * @Des 授权信息
			 * @Auth
			 * @Date
			 */
			searchAuthInfo() {
				this.$request.postJsonRequest(ApiOam.Find_Auth_Uri, {
					systemType: 2,
					projectId: this.$store.state.currentProjectId,
				}).then(result => {
					let data = Object.assign({}, result.data);
					if (!this.$checkEmpty(data)) {
						let currTime = new Date().getTime();
						let surplusTime = (data.expirationTime - (data.expirationTime % (24*60*60*1000))) - (currTime - (currTime % (24*60*60*1000)));
						let surplusDays = parseInt(surplusTime / (24*60*60*1000));
						// 剩余时间
						data.surplusDays = surplusDays;
						// 到期时间
						data.expirationDate = this.$moment(data.expirationTime).format('YYYY年MM月DD日');
						// falg 提醒
						data.warningFlag = !(surplusDays >= 30);
					}
					this.authInfo = Object.assign({}, data);
					this.$emit('changeAutoInfo', this.authInfo);
				}).catch(error => {
					console.error('授权信息查询异常', ApiOam.Find_Auth_Uri, error);
				})
			},// searchAuthInfo
			/**
			 * @Des 授权
			 * @Auth 
			 * @Date 
			 */
			warrant() {
				// 授权弹窗
				this.$refs.warrantDialog.openDialog({
					projectId: this.$store.state.currentProjectId,
					projectName: this.$store.state.currentProjectName,
				});
			},// warrant
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/License/LicenseDropDown.vue